/**
 * @file getZIndex
 * @author yuzong(yuzong@tencent.com)
 */
var zIndex = 500;
/**
 * 获取zIndex
 *
 * @return 返回zIndex
 */

export function getZIndex() {
  return zIndex += 3;
}